import { useQuery } from "@tanstack/react-query";
import { ApiClientError, api } from "./api";

export interface SessionUser {
  id: string;
  email: string;
  emailCanonical: string;
  displayName: string;
  role: "owner" | "admin" | "staff" | "viewer";
  /** GAC scopes (§7c). "*" is full access and is also the admin check. */
  scopes: string[];
}

/** `null` means definitively signed out; `undefined` means still loading. */
export function useSession() {
  const query = useQuery({
    queryKey: ["session"],
    queryFn: async () => {
      try {
        return await api<SessionUser>("/auth/me");
      } catch (err) {
        if (err instanceof ApiClientError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });

  return { user: query.data, isLoading: query.isLoading, error: query.error };
}
